// extracted by mini-css-extract-plugin
export default {"atlasPic":"index_atlasPic_RL4cc"};